import { ACTIONS, EVENTS, STATUS, type EventData } from "react-joyride";

export type TourDirection = "next" | "prev";

type TourEventInput = Pick<EventData, "type" | "action" | "index" | "status">;

export type TourCommand =
  | { kind: "go"; index: number; direction: TourDirection }
  | { kind: "skip" }
  | { kind: "complete" };

export function nextIndexAfterMissingTarget(
  stepCount: number,
  index: number,
  direction: TourDirection,
): number {
  if (direction === "next") return Math.min(index + 1, stepCount);
  return index > 0 ? index - 1 : index + 1;
}

const go = (from: number, to: number): TourCommand => ({
  kind: "go",
  index: to,
  direction: to > from ? "next" : "prev",
});

export function getTourCommand(
  { type, action, index, status }: TourEventInput,
  stepCount: number,
  direction: TourDirection,
): TourCommand | null {
  const isFinish = index >= stepCount;

  if (type === EVENTS.TARGET_NOT_FOUND) {
    if (isFinish) return { kind: "complete" };
    return go(index, nextIndexAfterMissingTarget(stepCount, index, direction));
  }

  if (type === EVENTS.TOUR_END && status === STATUS.SKIPPED) {
    return isFinish ? { kind: "complete" } : { kind: "skip" };
  }

  if (type !== EVENTS.STEP_AFTER) return null;

  if (action === ACTIONS.NEXT) {
    return isFinish ? { kind: "complete" } : go(index, index + 1);
  }
  if (action === ACTIONS.PREV) return go(index, Math.max(index - 1, 0));
  if (action === ACTIONS.CLOSE) return isFinish ? { kind: "complete" } : { kind: "skip" };

  return null;
}
